import React, { useRef, useState, useEffect, useCallback } from 'react';
import { getDb, getRealtimeDatabase  } from 'src/utils/firebase';
import { Joystick } from 'react-joystick-component';
import SquareMenu from './squareMenu';
import { v4 as uuidv4 } from 'uuid';
import useAuth from 'src/hooks/useAuth';
import lockClosedPNG from 'src/assets/images/lock_Red_64x64.png';
import lockOpenPNG from 'src/assets/images/lock_Lime_64x64.png';
import { useNavigate, useParams  } from 'react-router-dom';

import {
  Box,
  Typography,
  Card,
  Button,
  IconButton,
  Tooltip,
  styled,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  CircularProgress,
} from '@mui/material';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

import SwitchVideoIcon from '@mui/icons-material/SwitchVideo';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

import ItarraIcon from '../icons/ItarraIcon';
import HydralicSpoolValveIcon from '../icons/HydralicSpoolValveIcon';
import RearLinkageIcon from '../icons/RearLinkage';
import FrontLinkageIcon from '../icons/FrontLinkage';
import TiltIcon from '../icons/TiltIcon';

const servers = {
  iceServers: [
    {
      urls: "stun:stun.relay.metered.ca:80",
    },
    {
      urls: "turn:global.relay.metered.ca:80",
      username: "d6f74d479e2cb5a090a11cc5",
      credential: "cNKRbVd3XnF+GxED",
    },
    {
      urls: "turn:global.relay.metered.ca:80?transport=tcp",
      username: "d6f74d479e2cb5a090a11cc5",
      credential: "cNKRbVd3XnF+GxED",
    },
    {
      urls: "turn:global.relay.metered.ca:443",
      username: "d6f74d479e2cb5a090a11cc5",
      credential: "cNKRbVd3XnF+GxED",
    },
    {
      urls: "turns:global.relay.metered.ca:443?transport=tcp",
      username: "d6f74d479e2cb5a090a11cc5",
      credential: "cNKRbVd3XnF+GxED",
    },
],
  iceCandidatePoolSize: 10,
};

const CardCamera = styled(Card)(
  () => `
  position: relative;
      
  & > img {
    width: 100%;
    height: 325px;
    display: block;
    position: relative;
    z-index: 4;
  }
`
);

const CameraActions = styled(Box)(
  ({ theme }) => `
   position: absolute;
   left: 0;
   top: 0;
   width: 100%;
   height: 100%;
   z-index: 5;
   padding: ${theme.spacing(3)};
   background: linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,0) 0%,rgba(0,0,0,0.65) 95%,rgba(0,0,0,0.65) 100%);
`
);

const ButtonDark = styled(Button)(
  ({ theme }) => `
  background: rgba(0,0,0,.6);
  color: ${theme.colors.alpha.trueWhite[100]};
  font-size: ${theme.typography.pxToRem(12)};
  font-weight: normal;
  white-space: nowrap;
  height: 32px;
  padding: ${theme.spacing(0, 3)};
  margin: ${theme.spacing(0, 1, 1, 0)};

  &:hover {
    background: rgba(0,0,0,.75);
  }
`
);

const TypographyMain = styled(Typography)(
  ({ theme }) => `
  color: ${theme.colors.alpha.trueWhite[100]};
`
);

const TypographyLatency = styled(({ connectedVideo, connectedWRTCMessager, ...other }) => <Typography {...other} />)(
  ({ connectedVideo, connectedWRTCMessager }) => `
  color: ${(connectedVideo && connectedWRTCMessager) ? 'lime' : 'red'};
`
);

const IconButtonDark = styled(IconButton)(
  ({ theme }) => `
  background: rgba(0,0,0,.2);
  color: ${theme.colors.alpha.trueWhite[100]};
  border-radius: 50px;
  padding: ${theme.spacing(2)};

  &:hover {
    background: rgba(0,0,0,.75);
  }
`
);

function DemoConnect() {
  const { t } = useTranslation();

  let machineID = 'itarra_1';
  let userID = 'user1';

  const uid = uuidv4();
  const { user } = useAuth();

  const Dot = styled(Box)(
    () => `
    background: ${connectedVideo && connectedWRTCMessager ? "lime":"red"};
    border-radius: 20px;
    width: 6px;
    height: 6px;
  `
  );

  const locations = [
    {
      value: 'Rear_Camera',
      text: t('Rear_Camera')
    },
    {
      value: 'Front_Camera',
      text: t('Front_Camera')
    },
    {
      value: 'Dual_Camera',
      text: t('Dual_Camera')
    }
  ];
  
  const navigate = useNavigate();
  const selectedCam = useRef(0);
  const [connectedVideo, setconnectedVideo] = useState(false);
  const [connectedWRTCMessager, setconnectedWRTCMessager] = useState(false);
  const [latency, setLatency] = useState(0);
  const [isLocked, setIsLocked] = useState(true);
  const [mode, setMode] = useState('Front Linkage');
  const direction = useRef('STOP');
  const userMode = useRef('Front Linkage');
  const safetyEnabled = useRef(false);
  const firestore = getDb();
  const documentRef = firestore.collection('devices').doc(machineID).collection('control').doc('camera');
  const remoteVideo = useRef();
  const theme = useTheme();
  const themeColor = theme.palette.primary.main;
  const dataChannelTimeout = useRef(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [connectionSteps, setConnectionSteps] = useState([
    { label: 'Send Connection request to Machine', status: 'pending' },
    { label: 'Connection accepted by Machine', status: 'pending' },
    { label: 'Machine Setting Up Connection', status: 'pending' },
    { label: 'User device accepted Connection', status: 'pending' }
  ]);
  






  const hexToRGBA = (hex, alpha = 1) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };
  const themeColorWithAlpha = hexToRGBA(themeColor, 0.5);

  const [retryCount, setRetryCount] = useState(0);
  const pc = useRef(null);
  const iceCandidatesQueue = useRef([]);
 

  const changeMode = (mode) => {
    userMode.current = mode;
    if (mode === 'Exit') {

      if (pc.current) {
        pc.current.getSenders().forEach(sender => {
          if (sender.track) sender.track.stop();
        });
        pc.current.close();
        pc.current = null;
      }

      navigate(`/demo_complete/${activeUid}/tractor`);
    }
    setMode(mode);

  };

  const checkVideoAlive = useCallback(() => {
    if (remoteVideo.current && remoteVideo.current.readyState === 4) {
      setconnectedVideo(true);
     
    } else {
      setconnectedVideo(false);
      setLatency(0);
    }
    requestAnimationFrame(checkVideoAlive);
  }, []);

  useEffect(() => {
    requestAnimationFrame(checkVideoAlive);
  }, [checkVideoAlive]);
  

  const updateConnectionStep = (index, status) => {
    setConnectionSteps((prevSteps) => {
      const newSteps = [...prevSteps];
      newSteps[index].status = status;
      console.log(newSteps);
      console.log('upatde index:', index);
      return newSteps;
    });

    if (index === connectionSteps.length - 1 && status === 'completed') {
      setTimeout(() => {
        setOpenDialog(false);
      }, 500);
    }
  };

  const initConnection = useCallback(() => {
    const createPeerConnection = () => {
      try {
        pc.current = new RTCPeerConnection(servers);
        pc.current.onicecandidate = (event) => {
          if (event.candidate) {
            firestore.collection('devices').doc(machineID).collection(`${userID}_answerCandidates`).add(event.candidate.toJSON());
          }
        };
      } catch (error) {
        if (retryCount < 3) {
          setRetryCount(prevCount => prevCount + 1);
        } else {
          console.error("Failed to create RTCPeerConnection after multiple retries");
        }
      }
    };

    const setupMedia = async () => {
      const remoteStream = new MediaStream();
      pc.current.ontrack = (event) => {
        event.streams[0].getTracks().forEach((track) => {
          remoteStream.addTrack(track);
        });
      };
      remoteVideo.current.srcObject = remoteStream;
    };

    createPeerConnection();
    setupMedia();

    return () => {
      if (pc.current) {
        pc.current.close();
      }
    };
  }, [retryCount]);

  const updateCamera = () => {
    if (selectedCam.current === 2) {
      selectedCam.current = 0;
    } else {
      selectedCam.current += 1;
    }

    documentRef.update({ camera: locations[selectedCam.current].value })
      .then(() => {
        console.log('Document updated successfully');
      })
      .catch((error) => {
        console.error('Error updating document: ', error);
      });
  };

  const resetConnectionSteps = () => {
    setConnectionSteps([
      { label: 'Send Connection request to Machine', status: 'pending' },
      { label: 'Connection accepted by Machine', status: 'pending' },
      { label: 'Machine Setting Up Connection', status: 'pending' },
      { label: 'User device accepted Connection', status: 'pending' }
    ]);
  };

  const connectToTractor = async () => {
    try {
      resetConnectionSteps();
      await delay(1000);
      setconnectedVideo(false);

      console.log(connectionSteps);
      setOpenDialog(true);
      updateConnectionStep(0, 'completed');

      firestore.collection('devices').doc(machineID).get().then((doc) => {
        if (doc.exists) {
          updateConnectionStep(1, 'completed');

          let userInfo = null;
          if (userID === 'user1') {
            userInfo = doc.data().user1;
          } else {
            userInfo = doc.data().user2;
          }
          userInfo.state = "reset";
          userInfo.ui = uid;
          userInfo.user = user;
          if (userInfo && userInfo.answer) {
            delete userInfo.answer;
          }
          firestore.collection('devices').doc(machineID).update({ [userID]: userInfo });
          updateConnectionStep(2, 'completed');
        } else {
          console.log("[ERROR][connectToTractor] No such document!");
          updateConnectionStep(1, 'failed');
          updateConnectionStep(2, 'failed');
        }
      }).catch((error) => {
        console.log("[ERROR][connectToTractor] Error getting document:", error);
        updateConnectionStep(1, 'failed');
        updateConnectionStep(2, 'failed');
      });
    } catch (error) {
      console.error('[ERROR][connectToTractor] Error writing document: ', error);
      updateConnectionStep(1, 'failed');
      updateConnectionStep(2, 'failed');
    }
  };

  useEffect(() => {
    const connectToRemoteMachine = async () => {
      await connectToTractor();
    };
    connectToRemoteMachine();
    initConnection();
  }, [initConnection]);

  
  

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  function csvToDoc(csvString) {
      // Split the CSV string into an array of values
      const values = csvString.split(',').map(value => parseInt(value));

      // Create the doc object
      const doc = {};

      // Set the first value to messageCounter
      doc["messageCounter"] = values[0];
      
      // Assign the second value to rtt
      doc["rtt"] = values[1];
      
      // Boolean values (using integer values, 0 or 1)
      doc["driveLeftForward"] = !!values[2];
      doc["driveRightForward"] = !!values[3];
      doc["driveLeftBackwards"] = !!values[4];
      doc["driveRightBackwards"] = !!values[5];
      doc["threePhase"] = !!values[6];
      doc["singlePhase"] = !!values[7];
      doc["lights"] = !!values[8];
      doc["auxRelayOne"] = !!values[9];
      doc["auxRelayTwo"] = !!values[10];
      doc["auxRelayThree"] = !!values[11];
      doc["startStop"] = !!values[12];
      doc["estopStatus"] = !!values[13];
      doc["frontLiftActive"] = !!values[14];
      doc["rearLiftActive"] = !!values[15];
      doc["carriageLeftActive"] = !!values[16];
      doc["carriageRightActive"] = !!values[17];
      doc["oilOk"] = !!values[18];
      doc["remoteOrBle"] = !!values[19];
      doc["safetyActive"] = !!values[20];
      doc["carrageDown"] = !!values[21];
      doc["carrageUp"] = !!values[22];
      doc["frontLiftUp"] = !!values[23];
      doc["frontLiftDown"] = !!values[24];
      doc["rearLiftUp"] = !!values[25];
      doc["rearLiftDown"] = !!values[26];
      doc["auxfront1"] = !!values[27];
      doc["auxfront2"] = !!values[28];
      doc["auxrear1"] = !!values[29];
      doc["auxrear2"] = !!values[30];
      doc["auxrear3"] = !!values[31];
      doc["auxrear4"] = !!values[32];
      doc["spare1"] = !!values[33];
      doc["spare2"] = !!values[34];

      return doc;
  }
  function docToCsv(doc) {
      // Convert the doc object back to an array of values in the same order as the original CSV
      const values = [
          doc["messageCounter"],
          doc["rtt"],
          +doc["driveLeftForward"],  // Convert boolean to 0 or 1
          +doc["driveRightForward"],
          +doc["driveLeftBackwards"],
          +doc["driveRightBackwards"],
          +doc["threePhase"],
          +doc["singlePhase"],
          +doc["lights"],
          +doc["auxRelayOne"],
          +doc["auxRelayTwo"],
          +doc["auxRelayThree"],
          +doc["startStop"],
          +doc["estopStatus"],
          +doc["frontLiftActive"],
          +doc["rearLiftActive"],
          +doc["carriageLeftActive"],
          +doc["carriageRightActive"],
          +doc["oilOk"],
          +doc["remoteOrBle"],
          +doc["safetyActive"],
          +doc["carrageDown"],
          +doc["carrageUp"],
          +doc["frontLiftUp"],
          +doc["frontLiftDown"],
          +doc["rearLiftUp"],
          +doc["rearLiftDown"],
          +doc["auxfront1"],
          +doc["auxfront2"],
          +doc["auxrear1"],
          +doc["auxrear2"],
          +doc["auxrear3"],
          +doc["auxrear4"],
          +doc["spare1"],
          +doc["spare2"]
      ];

      // Join the values into a CSV string
      return values.join(',');
  }

  useEffect(() => {
    const machineDocRef = firestore.collection('devices').doc(machineID);

    const unsubscribe = machineDocRef.onSnapshot((snapshot) => {
      if (snapshot.exists) {
        const data = snapshot.data();

        if (data[userID].state === 'call') {
          updateConnectionStep(1, 'completed');
          let userInfo = data[userID];
          userInfo.state = "ringing";

          firestore.collection('devices').doc(machineID).update({ [userID]: userInfo }).then(() => {
            answerCall();
          })
            .catch((error) => {
              console.error('Error updating document: ', error);
            });

        } else if (data[userID].state === 'ringing') {
          const dataChannelOptions = {
            ordered: true,
            maxRetransmits: 0,
            reliable: false,
            protocol: 'json'
          };
          const dataChannel = pc.current.createDataChannel('latency_send_channel', dataChannelOptions);

          dataChannel.onopen = () => {
            console.log('Data channel is open');
          };

          dataChannel.onclose = () => {
            console.log('Data channel is closed');
          };

          const resetTimeout = () => {
            if (dataChannelTimeout.current) {
              clearTimeout(dataChannelTimeout.current);
            }
            dataChannelTimeout.current = setTimeout(() => {
              setLatency(0);
              setconnectedVideo(false);
              setconnectedWRTCMessager(false);
            }, 5000);
          };

          let updateRrt = 0;
          dataChannel.onmessage = (event) => {
            const receivedMessage = event.data;
            // console.log('Received message:', receivedMessage);
            const dataMessage = csvToDoc(receivedMessage);
            

            // if (direction.current !== 'STOP' && safetyEnabled.current && userMode.current === 'Drive') {
            //   if (direction.current === "RIGHT") {
            //     dataMessage["driveLeftForward"] = true;
            //     dataMessage["driveRightForward"] = false;
            //     dataMessage["driveLeftBackwards"] = false;
            //     dataMessage["driveRightBackwards"] = true;
            //   } else if (direction.current === "LEFT") {
            //     dataMessage["driveLeftForward"] = false;
            //     dataMessage["driveRightForward"] = true;
            //     dataMessage["driveLeftBackwards"] = true;
            //     dataMessage["driveRightBackwards"] = false;
            //   } else if (direction.current === "FORWARD") {
            //     dataMessage["driveLeftForward"] = true;
            //     dataMessage["driveRightForward"] = true;
            //     dataMessage["driveLeftBackwards"] = false;
            //     dataMessage["driveRightBackwards"] = false;
            //   } else if (direction.current === "BACKWARD") {
            //     dataMessage["driveLeftForward"] = false;
            //     dataMessage["driveRightForward"] = false;
            //     dataMessage["driveLeftBackwards"] = true;
            //     dataMessage["driveRightBackwards"] = true;
            //   }
            // } else {
            //   dataMessage["driveLeftBackwards"] = false;
            //   dataMessage["driveRightForward"] = false;
            //   dataMessage["driveLeftForward"] = false;
            //   dataMessage["driveRightBackwards"] = false;
            // }

            if (userMode.current === 'Tilt' && direction.current !== 'STOP' && safetyEnabled.current) {
              if (direction.current === "BACKWARD") {
                dataMessage["carrageDown"] = true;
              } else {
                dataMessage["carrageDown"] = false;
              }
              if (direction.current === "FORWARD") {
                dataMessage["carrageUp"] = true;
              } else {
                dataMessage["carrageUp"] = false;
              }
            } else {
              dataMessage["carrageUp"] = false;
              dataMessage["carrageDown"] = false;
            }

            if (userMode.current === 'Front Linkage' && direction.current !== 'STOP' && safetyEnabled.current === true) {
              if (direction.current === "FORWARD") {
                dataMessage["frontLiftUp"] = true;
              } else {
                dataMessage["frontLiftUp"] = false;
              }
              if (direction.current === "BACKWARD") {
                dataMessage["frontLiftDown"] = true;
              } else {
                dataMessage["frontLiftDown"] = false;
              }
              // if (direction.current === "LEFT") {
              //   dataMessage["auxfront1"] = true;
              // } else {
              //   dataMessage["auxfront1"] = false;
              // }
              // if (direction.current === "RIGHT") {
              //   dataMessage["auxfront2"] = true;
              // } else {
              //   dataMessage["auxfront2"] = false;
              // }
            } else {
              dataMessage["frontLiftUp"] = false;
              dataMessage["frontLiftDown"] = false;
              dataMessage["auxfront1"] = false;
              dataMessage["auxfront2"] = false;
            }

            // if (userMode.current === 'Rear Linkage' && direction.current !== 'STOP' && safetyEnabled.current === true) {
            //   // console.log('Rear Linkage');
            //   if (direction.current === "FORWARD") {
            //     dataMessage["rearLiftUp"] = true;
            //   } else {
            //     dataMessage["rearLiftUp"] = false;
            //   }
            //   if (direction.current === "BACKWARD") {
            //     dataMessage["rearLiftDown"] = true;
            //   } else {
            //     dataMessage["rearLiftDown"] = false;
            //   }
            //   if (direction.current === "LEFT") {
            //     dataMessage["auxfront1"] = true;
            //   } else {
            //     dataMessage["auxfront1"] = false;
            //   }
            //   if (direction.current === "RIGHT") {
            //     dataMessage["auxfront2"] = true;
            //   } else {
            //     dataMessage["auxfront2"] = false;
            //   }
            // } else {
            //   dataMessage["rearLiftUp"] = false;
            //   dataMessage["rearLiftDown"] = false;
            //   dataMessage["auxfront1"] = false;
            //   dataMessage["auxfront2"] = false;
            // }

            dataChannel.send(docToCsv(dataMessage));

            if (performance.now() - updateRrt > 2000) {
              let rrt = (parseInt(dataMessage['rtt']));
              setconnectedWRTCMessager(true);
              setLatency(parseInt(rrt, 10));
              updateRrt = performance.now();
            }

            resetTimeout();
          };

          dataChannel.onerror = (error) => {
            console.error('Data channel error:', error);
          };
        }
      } else {
        console.log('Machine document does not exist.');
      }
    }, (error) => {
      console.error('Error listening to machine document:', error);
    });

    return () => unsubscribe();
  }, []);

  const answerCall = async () => {
    await delay(2000);
    setconnectedVideo(true);
    const answerCandidates = firestore.collection('devices').doc(machineID).collection(`${userID}_answerCandidates`);
    const offerCandidates = firestore.collection('devices').doc(machineID).collection(`${userID}_offerCandidates`);

    pc.current.onicecandidate = (event) => {
      if (event.candidate) {
        answerCandidates.add(event.candidate.toJSON());
      }
    };

    const callData = (await firestore.collection('devices').doc(machineID).get()).data();
    const offerDescription = callData[userID].offer;
    await pc.current.setRemoteDescription(new RTCSessionDescription(offerDescription));

    // Add queued ICE candidates
    while (iceCandidatesQueue.current.length > 0) {
      const candidate = iceCandidatesQueue.current.shift();
      pc.current.addIceCandidate(new RTCIceCandidate(candidate));
    }

    const answerDescription = await pc.current.createAnswer();
    await pc.current.setLocalDescription(answerDescription);

    const answer = {
      type: answerDescription.type,
      sdp: answerDescription.sdp,
    };

    await firestore.collection('devices').doc(machineID).update({ [`${userID}.answer`]: answer });

    offerCandidates.onSnapshot((snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type === 'added') {
          updateConnectionStep(2, 'completed');
          let data = change.doc.data();
          const candidate = new RTCIceCandidate(data);
          if (pc.current.remoteDescription) {
            pc.current.addIceCandidate(candidate);
          } else {
            iceCandidatesQueue.current.push(candidate);
          }
        }
      });
    });
  };

  const handleMove = (event) => {
    direction.current = event.direction;
  };

  const handleStop = () => {
    direction.current = 'STOP';
  };

  const handleUnlockMove = () => {
    setIsLocked(false);
    safetyEnabled.current = true;
  };

  const handleUnlockStop = () => {
    setIsLocked(true);
    safetyEnabled.current = false;
  };

  const getModeIcon = (mode) => {
    switch (mode) {
      case 'Drive':
        return <ItarraIcon style={{ color: 'lime' }} />;
      case 'Tilt':
        return <TiltIcon size={20} style={{ color: 'lime' }} />;
      case 'Front Linkage':
        return <FrontLinkageIcon style={{ color: 'lime' }} />;
      case 'Rear Linkage':
        return <RearLinkageIcon style={{ color: 'lime' }} />;
      case 'Front Hydraulics':
        return <HydralicSpoolValveIcon style={{ color: 'lime' }} />;
      case 'Rear Hydraulics 1':
        return <HydralicSpoolValveIcon style={{ color: 'lime' }} />;
      case 'Rear Hydraulics 2':
        return <HydralicSpoolValveIcon style={{ color: 'lime' }} />;
      default:
        return <LockIcon style={{ color: 'lime' }} />;
    }
  };

  // Callback for changes in connectedVideo and connectedWRTCMessager
  useEffect(() => {
    if (connectedVideo && connectedWRTCMessager) {
      updateConnectionStep(3, 'completed');
      // console.log('Both video and WebRTC messager are connected');
    } else {
      updateConnectionStep(3, 'pending');
      // console.log('Video or WebRTC messager is disconnected');
    }
  }, [connectedVideo, connectedWRTCMessager]);

  // Keyboard event handlers
  useEffect(() => {
    const handleKeyDown = (event) => {
      // console.log('Key pressed:', event.key);
      switch (event.key) {
        case 'ArrowUp':
          handleMove({ direction: 'FORWARD' });
          break;
        case 'ArrowDown':
          handleMove({ direction: 'BACKWARD' });
          break;
        case 'ArrowLeft':
          handleMove({ direction: 'LEFT' });
          break;
        case 'ArrowRight':
          handleMove({ direction: 'RIGHT' });
          break;
        case 'Control':
          handleUnlockMove();
          break;
        default:
          break;
      }
    };

    const handleKeyUp = (event) => {
      handleStop();
      if (event.key === 'Control') handleUnlockStop();
    };

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  const { uid: activeUid } = useParams();
const rtdb = getRealtimeDatabase();

useEffect(() => {
  if (!rtdb || !activeUid) {
    return () => {};   // return a no-op cleanup to satisfy ESLint
  }

  const ref = rtdb.ref("demo_current_tractor");
  ref.on("value", (snapshot) => {
    const current = snapshot.val();
    if (!current || current.uid !== activeUid) {
      console.log("❌ UID mismatch, redirecting to demo_complete");
      navigate(`/demo_complete/${activeUid}/tractor`);
    }
  });

  return () => {
    ref.off();
  };
}, [rtdb, activeUid, navigate]);

  // Gamepad event handlers
  useEffect(() => {
    const handleGamepadConnected = (event) => {
      console.log('Gamepad connected:', event.gamepad);
      const gamepadIndex = event.gamepad.index;

      const pollGamepad = () => {
        const gamepad = navigator.getGamepads()[gamepadIndex];
        if (gamepad) {
          const { axes, buttons } = gamepad;

          if (axes[1] < -0.5) handleMove({ direction: 'FORWARD' });
          else if (axes[1] > 0.5) handleMove({ direction: 'BACKWARD' });
          else if (axes[0] < -0.5) handleMove({ direction: 'LEFT' });
          else if (axes[0] > 0.5) handleMove({ direction: 'RIGHT' });
          else handleStop();

          if (buttons[0].pressed) handleUnlockMove();
          else handleUnlockStop();

          requestAnimationFrame(pollGamepad);
        }
      };

      pollGamepad();
    };

    const handleGamepadDisconnected = (event) => {
      console.log('Gamepad disconnected:', event.gamepad);
    };

    window.addEventListener('gamepadconnected', handleGamepadConnected);
    window.addEventListener('gamepaddisconnected', handleGamepadDisconnected);

    return () => {
      window.removeEventListener('gamepadconnected', handleGamepadConnected);
      window.removeEventListener('gamepaddisconnected', handleGamepadDisconnected);
    };
  }, []);

  return (
    <div style={{
      height: '100vh',
      width: '100vw',
      overflow: 'hidden',
      padding: '5px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      transform: 'rotate(0deg)',
    }}>
      <CardCamera style={{ height: '100%', boxSizing: 'border-box' }}>
        <CameraActions
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box display="flex" justifyContent="space-between">
            <Box>
             
                <div
                  style={{
                    position: 'absolute',
                    top: '15px',
                    left: '15px'
                  }}
                >
                  <SquareMenu setMenu={changeMode} />
                </div>
              
            </Box>
            <Box>
              <ButtonDark 
                startIcon={<Dot />} 
                size="small"
                onClick={connectToTractor}
              >
                {connectedVideo && connectedWRTCMessager ? t('Connected') : t('NOT Connected')}
              </ButtonDark>
              <ButtonDark startIcon={isLocked ? <LockIcon style={{ color: 'red' }} /> : <LockOpenIcon style={{ color: 'lime' }} />} size="small" >
                {t('Locked')}
              </ButtonDark>
              <ButtonDark startIcon={getModeIcon(mode)} size="small" >
                {t(mode)}
              </ButtonDark>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              sx={{ maxWidth: 170 }}
            >
              <TypographyMain
                gutterBottom
                fontWeight="bold"
                textAlign="center"
              >
                Stats
              </TypographyMain>
              <TypographyLatency
                sx={{ mb: 2 }}
                textAlign="center"
                connectedVideo={connectedVideo}
                connectedWRTCMessager={connectedWRTCMessager}
              >
                {latency + ' ms'}
              </TypographyLatency>
              <Tooltip arrow placement="top" title={t('Switch Video')}>
                <IconButtonDark
                  onClick={() => {
                    updateCamera();
                  }}
                >
                  <SwitchVideoIcon />
                </IconButtonDark>
              </Tooltip>
            </Box>
          </Box>

          <Box
            sx={{
              width: '100%'
            }}
            display="flex"
            alignSelf="flex-end"
            alignItems="flex-end"
            justifyContent="space-between"
          >
            <Box>
              <Joystick
                size={102}
                baseColor="rgba(255, 255, 255, 0.1)"
                stickImage={isLocked ? lockClosedPNG : lockOpenPNG} throttle={50}
                move={handleUnlockMove}
                stop={handleUnlockStop}
              />
            </Box>
            <Box>
              <Joystick
                size={100}
                baseColor="rgba(255, 255, 255, 0.1)"
                stickColor={themeColorWithAlpha}
                move={handleMove}
                stop={handleStop}
              />
            </Box>
          </Box>
        </CameraActions>
        <video
          muted
          ref={remoteVideo}
          autoPlay
          playsInline
          poster="/static/images/media/Background_Img_no_logo.png"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            boxSizing: 'border-box'
          }}
        />
      </CardCamera>

      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle style={{ display: 'flex', alignItems: 'center' }}>
          <CircularProgress size={15} style={{ marginRight: '10px' }} />
          {t('Connecting to Machine')}
        </DialogTitle>
        <DialogContent style={{ overflow: 'hidden' }}>
          <List>
            {connectionSteps.map((step, index) => (
              <ListItem key={index}>
                <ListItemText primary={t(step.label)} style={{ fontSize: '12px', paddingRight: '10px' }} />
                <ListItemIcon style={{ marginLeft: '10px' }}>
                  {step.status === 'completed' ? <CheckIcon style={{ color: 'lime', fontSize: '16px' }} /> : step.status === 'failed' ? <CloseIcon color="error" style={{ fontSize: '16px' }} /> : null}
                </ListItemIcon>
              </ListItem>
            ))}
          </List>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default DemoConnect;
